import { render } from "./Template1View.vue?vue&type=template&id=9862a7d8"
import script from "./Template1View.vue?vue&type=script&lang=js"
export * from "./Template1View.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__